export const TJH_COUNTRIES = {
  AU: 'Australia',
  CA: 'Canada',
  GB: 'United Kingdom',
  US: 'United States',
  AT: 'Austria',
  DE: 'Germany',
  CH: 'Switzerland',
  BE: 'Belgium',
  FR: 'France',
};

// TODO: this should probably come from an Eagle endpoint
const tjhAvailabiltyDict = {
  'en-GB': ['AU', 'CA', 'GB', 'US'],
  'en-US': ['AU', 'CA', 'GB', 'US'],
  de: ['AT', 'DE', 'CH'],
  fr: ['BE', 'CA', 'CH', 'FR'],
};

export const getTJHAvailability = locale => tjhAvailabiltyDict[locale];

// TODO: These need localising properly. Prismic?
export const getTJHCountryOptions = locale =>
  getTJHAvailability(locale).map(country => ({
    label: TJH_COUNTRIES[country],
    value: country,
  }));

export const getAddressString = values => {
  const doorString = values.door ? `${values.door}` : '';
  const streetString = values.street ? ` ${values.street}` : '';
  const cityString = values.city ? ` ${values.city}` : '';
  const postcodeString = values.postcode ? ` ${values.postcode}` : '';
  const countryName = TJH_COUNTRIES[values.country]
    ? ` ${TJH_COUNTRIES[values.country]}`
    : '';
  return `${doorString}${streetString}${cityString}${postcodeString}${
    countryName
  }`;
};

export const isAddressFilled = values => {
  const { door, street, country, city, postcode } = values;
  if (!door || !street || !country || !city || !postcode) {
    return false;
  }
  return !!(door && street && country && city && postcode);
};



// WEBPACK FOOTER //
// ./src/client/js/view/components/CreationForm/HomeAddress/helpers.js